<script lang="ts">
    import {Vue, Component} from 'vue-facing-decorator'

    @Component
    export class OrderSelectionMixin extends Vue {
        async setSelectedOrderAndCompany() {
            if (
                this.order.agentCompanyId &&
                this.order.agent?.id &&
                this.order.clientType !== 'DIRECT_SALES' &&
                !this.isCorporate
            ) {
                let company
                let agent
                const isCorporate = this.order.clientType === 'CORPORATE'
                try {
                    const id = isCorporate ? this.order.clientId : this.order.agentCompanyId
                    company = (await this.$api.companies.get({id})).companies[0]
                    if (!isCorporate) {
                        agent = (
                            await this.$api.persons.get({
                                id: this.order.agent.id,
                                companyId: this.order.agentCompanyId,
                            })
                        ).users[0]
                    }
                    // eslint-disable-next-line no-empty
                } catch (e) {}

                if (company) {
                    persistentStore.SET_SELECTED_COMPANY_AND_AGENT({
                        agent,
                        company,
                        takeClientMethod: isCorporate ? 'persons' : 'privateClients',
                    })
                }
            }

            persistentStore.SET_SELECTED_ORDER_ID(this.order.orderId)
        }

        resetSelectedOrderAndCompany() {
            persistentStore.SET_SELECTED_ORDER_ID(null)
            persistentStore.SET_SELECTED_COMPANY_AND_AGENT(null)
            persistentStore.SET_SELECTED_DESTINATION(null)
        }

        get isCorporate() {
            return authStore.isCorporate
        }
    }

    export default OrderSelectionMixin
</script>
